var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9998 67.8334C54.0286 67.8334 67.8332 54.0289 67.8332 37.0001C67.8332 19.9713 54.0286 6.16675 36.9998 6.16675C19.9711 6.16675 6.1665 19.9713 6.1665 37.0001C6.1665 54.0289 19.9711 67.8334 36.9998 67.8334ZM41.2425 24.1487C41.2425 24.2967 41.1932 24.4447 41.1932 24.5927L38.4305 42.5008H35.5692L32.8065 24.5927C32.8065 24.4447 32.7572 24.2967 32.7572 24.1487C32.7572 21.9287 34.9772 20.5967 36.9998 20.5967C39.0225 20.5967 41.2425 21.9287 41.2425 24.1487ZM40.8972 48.9634C40.8972 51.1341 39.1705 52.8607 36.9998 52.8607C34.8292 52.8607 33.1025 51.1341 33.1025 48.9634C33.1025 46.7928 34.8292 45.0661 36.9998 45.0661C39.1705 45.0661 40.8972 46.7928 40.8972 48.9634Z",
    fill: "#D50000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.4117ca5549ae8195393e1c386ac4320c.svg";
export { ForwardRef as ReactComponent };